// @ts-ignore
import Glide from '@glidejs/glide/dist/glide.esm';
import {Utils} from "./Utils";
export class ImageSliderClass {
    private glide: any = null;
    private slider: Element;
    private bullets: NodeListOf<HTMLElement>;
    private slidesCount: number = 0;
    private maxIndex: number = 0;
    private currentStep: number = 0;

    constructor(slider: Element) {
        this.slider = slider;
        this.bullets = this.slider.querySelectorAll('.o-hero__buttons-bullet');
        this.slidesCount = this.bullets.length;

        if (this.slider) {
            this.init();
        }
    }
    init() {
        this.glide = new Glide(this.slider, {
            type: 'slider',
            gap: 24,
            autoplay: false,
            perView: 3,
            bound: true,
            classes: {
                direction: {
                    ltr: 'dir-ltr',
                    rtl: 'dir-rtl'
                },
                slider: 'is-slider',
                carousel: 'is-carousel',
                swipeable: 'is-swipeable',
                dragging: 'is-dragging',
                cloneSlide: 'is-clone',
                activeNav: 'is-active',
                activeSlide: 'is-active',
                disabledArrow: 'is-disabled',
                controls: 'c-slider__arrows',
                backArrow: 'c-slider__arrow-prev',
                nextArrow: 'c-slider__arrow-next',
            },
            breakpoints: {
                600: {
                    perView: 1
                },
                720: {
                    perView: 2
                },
                1176:{
                    perView: 3
                }
            }
        });

        this.glide.mount();
    }
}

Utils.executeWhenDocumentIsReady(() => {
    document.querySelectorAll('.c-image-slider__carousel').forEach((item) => {
        new ImageSliderClass(item);
    });
    /* If Accordion, do resize after opening, to reinit slider */
    const accordionHeaders = document.querySelectorAll('.c-accordion__header');

    accordionHeaders.forEach((accordionHeader) => {
        accordionHeader.addEventListener('click', function () {
            setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 100);
        });
    })
});
